/** Inline stroke icons (lucide-style, decorative: every icon sits next to text or inside a labelled button). */
const svg = (paths: string, size = 16, width = 2) => {
  const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  s.setAttribute('width', String(size));
  s.setAttribute('height', String(size));
  s.setAttribute('viewBox', '0 0 24 24');
  s.setAttribute('fill', 'none');
  s.setAttribute('stroke', 'currentColor');
  s.setAttribute('stroke-width', String(width));
  s.setAttribute('stroke-linecap', 'round');
  s.setAttribute('stroke-linejoin', 'round');
  s.setAttribute('aria-hidden', 'true');
  s.setAttribute('class', 'ico');
  s.innerHTML = paths;
  return s;
};

export const icon = {
  mark: (size = 16) =>
    svg('<path d="M4 18V6"/><path d="M9 18V10"/><path d="M14 18V4"/><path d="M19 18v-6"/>', size, 2.4),
  mic: (size = 18) =>
    svg('<rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0"/><path d="M12 17v4"/>', size),
  down: () => svg('<path d="M6 9l6 6 6-6"/>', 18),
  back: (size = 18) => svg('<path d="M15 18l-6-6 6-6"/>', size),
  right: (size = 14) => svg('<path d="M9 18l6-6-6-6"/>', size),
  hang: (size = 28) => svg('<path d="M3 15c5-4 13-4 18 0l-2 3-4-1v-3c-2-.6-4-.6-6 0v3l-4 1z"/>', size, 2.2),
  car: (size = 22) =>
    svg('<path d="M5 17h14v-5l-2-5H7l-2 5z"/><circle cx="8" cy="17" r="2"/><circle cx="16" cy="17" r="2"/>', size, 1.8),
  out: (size = 16) =>
    svg('<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><path d="M10 17l5-5-5-5"/><path d="M15 12H3"/>', size),
  check: (size = 16) => svg('<path d="M20 6L9 17l-5-5"/>', size, 2.2),
  open: (size = 14) => svg('<path d="M7 17L17 7"/><path d="M8 7h9v9"/>', size),
  bot: (size = 16) =>
    svg(
      '<rect x="4" y="8" width="16" height="12" rx="3"/><path d="M12 4v4"/><circle cx="12" cy="3" r="1"/><path d="M9 13v2"/><path d="M15 13v2"/>',
      size,
    ),
  folder: (size = 16) =>
    svg('<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>', size),
  book: (size = 16) =>
    svg('<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"/><path d="M4 19.5V21h16"/>', size),
  pulse: (size = 16) => svg('<path d="M3 12h4l3-8 4 16 3-8h4"/>', size),
  shield: (size = 16) => svg('<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/>', size),
  plus: (size = 16) => svg('<path d="M12 5v14"/><path d="M5 12h14"/>', size),
  branch: (size = 14) =>
    svg(
      '<circle cx="6" cy="5" r="2"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="7" r="2"/><path d="M6 7v10"/><path d="M18 9c0 5-12 3-12 8"/>',
      size,
    ),
  refresh: (size = 14) => svg('<path d="M21 12a9 9 0 1 1-3-6.7L21 8"/><path d="M21 3v5h-5"/>', size),
  stop: (size = 14) => svg('<rect x="6" y="6" width="12" height="12" rx="2"/>', size),
  send: (size = 16) => svg('<path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4z"/>', size),
  globe: (size = 14) =>
    svg('<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18"/>', size),
  help: (size = 16) =>
    svg(
      '<circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 0 1 5 .5c0 1.5-2.5 2-2.5 3.5"/><path d="M12 17h.01"/>',
      size,
    ),
  link: (size = 12) =>
    svg(
      '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>',
      size,
    ),
};
